import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, usePathname, useSearchParams } from 'src/routes/hooks';

import { CONFIG } from 'src/config-global';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function AuthGuard({ children }) {
  const router = useRouter();

  const pathname = usePathname();

  const searchParams = useSearchParams();

  const { authenticated, loading } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const createQueryString = useCallback(
    (name, value) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams]
  );

  // const authenticateUser = async () => {

  //   // Example API call
  //   try {
  //     const response = await fetch(signInPath, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         // Add necessary credentials here, e.g., email and password
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Authentication failed');
  //     }

  //     const data = await response.json();
  //     setAuthToken(data.token); // Store the token in context or local storage
  //     router.replace('/dashboard'); // Redirect to the dashboard
  //   } catch (error) {
  //     console.error(error);
  //     // Optionally handle error state (e.g., show a notification)
  //   }
  // };

  const checkPermissions = async () => {
    if (loading) {
      return;
    }

    if (!authenticated) {
      const { method } = CONFIG.auth;

      const signInPath = paths.auth.login;

      const href = `${signInPath}?${createQueryString('returnTo', pathname)}`;

      // authenticateUser();

      router.replace(signInPath);
      return;
    }

    setIsChecking(false);
  };

  useEffect(() => {
    checkPermissions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, loading]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
